import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { fires } from "../firebase";

export default function AdminRoute() {
  const { currentUser } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) {
      setLoading(false);
      return;
    }

    fires
      .collection("admin")
      .doc(currentUser.uid)
      .get()
      .then((snapshot) => {
        // Allow any user in the admin collection to access AdminRoute
        // Individual components will handle their own role restrictions
        if (snapshot.exists) {
          setIsAdmin(true);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error checking admin access:", error);
        setLoading(false);
      });
  }, [currentUser]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center" style={{ minHeight: "100vh" }}>
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3">Checking admin access...</p>
        </div>
      </div>
    );
  }

  return currentUser && isAdmin ? <Outlet /> : <Navigate to="/" replace />;
} 